export const FETCH_COLUMN_ONE = "FETCH_COLUMN_ONE";
